import { createFileRoute } from '@tanstack/react-router';

import { PackagePage } from '@/features/subcontracts/package-page';

export const Route = createFileRoute('/_app/projects/$projectId/subcontracts/packages/$packageId')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId, packageId } = Route.useParams();
  return <PackagePage projectId={projectId} packageId={packageId} />;
}
